module.exports = __webpack_public_path__ + "img/2019110803.295e1f68.jpg";